import { render, staticRenderFns } from "./TopBookings.vue?vue&type=template&id=50c30303&"
import script from "./TopBookings.vue?vue&type=script&lang=js&"
export * from "./TopBookings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports